

























import { Component, Vue } from "vue-property-decorator";
@Component
export default class coupon extends Vue {
  list: any = [
    {
      id: "0",
      name: "一周年全场通用优惠券",
      title: "2022/09/01～2021/12/10",
      titles: "将于7天后过期",
      totle: "规则说明此优惠券仅限查询报告选择支付方式时使用",
      text: "可使用",
    },
    {
      id: "1",
      name: "一周年全场通用优惠券",
      title: "2022/09/01～2021/12/10",
      titles: "将于7天后过期",
      totle: "规则说明此优惠券仅限查询报告选择支付方式时使用",
      text: "已使用",
    },
    {
      id: "2",
      name: "一周年全场通用优惠券",
      title: "2022/09/01～2021/12/10",
      titles: "将于7天后过期",
      totle: "规则说明此优惠券仅限查询报告选择支付方式时使用",
      text: "可使用",
    },
  ];
}
